import axios from "./index";

//顶部分类
export const getHead_list = async () => await axios.post('/api/index/head_list')

// 首页（除学校以外数据） /api/index
export const getIndex = async () => await axios.post('/api/index')

// 学校列表 /api/index/school_list
export const getSchool_list = async (data: any) => await axios.post('/api/index/school_list', data)

//文章列表 /api/index/article_list
export const getArticle_list = async (data: any) => await axios.post("/api/index/article_list", data)

// 发布调查问卷 /api/index/do_feedback
export const getDo_feedback = async (data: any) => await axios.post("/api/index/do_feedback", data)

//文章详情 /api/index/article_detail
export const getArticle_detail = async (data: any) => await axios.post('/api/index/article_detail', data)

//友情链接 /api/index/get_links
export const get_links = async (data: any) => await axios.post("/api/index/get_links", data)

//上传文件 /api/common/upload
export const upload = async (data: any) => await axios.post('/api/common/upload', data)

// 参会单位报名 /api/index/do_signup
export const postDo_signup = async (data: any) => await axios.post("/api/index/do_signup", data)